import { render, staticRenderFns } from "./switchJob.vue?vue&type=template&id=50dc1f2e&scoped=true&"
import script from "./switchJob.vue?vue&type=script&lang=js&"
export * from "./switchJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dc1f2e",
  null
  
)

export default component.exports